import { MarkAttendanceForParticipations } from "apps/console/modules/program/workflow/associateProgram/attendance/details";

export default function ActivityParticipationMarkAttendanceInMyExperience() {
  return <MarkAttendanceForParticipations hasProgramWriteAuthority />;
}
